export interface CreateVacancyBaseModel {
  company_id: string | null;
}
